import Logo from "../../images/logo.svg"
export default Logo
